import { html } from 'lit';
const FigmaDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#0ACF83" d="M8.418 22.503a3.42 3.42 0 0 0 3.418-3.417v-3.417H8.418a3.418 3.418 0 0 0 0 6.834"/><path fill="#A259FF" d="M5.001 12.251a3.42 3.42 0 0 1 3.417-3.417h3.418v6.835H8.418a3.42 3.42 0 0 1-3.417-3.418"/><path fill="#F24E1E" d="M5.001 5.417A3.42 3.42 0 0 1 8.42 2h3.417v6.834H8.419A3.42 3.42 0 0 1 5 5.417"/><path fill="#FF7262" d="M11.836 2h3.417a3.418 3.418 0 0 1 0 6.834h-3.417z"/><path fill="#1ABCFE" d="M18.67 12.251a3.418 3.418 0 0 1-6.834 0 3.418 3.418 0 0 1 6.834 0"/>
  </svg>
`;
export default FigmaDuotone;
